module.exports = __webpack_public_path__ + "static/media/fruit-cherry-1.20739520.png";